import { upsertHolidaySchedule } from '../graphql/mutations';
import { getHolidayScheduleStatus } from '../graphql/queries';
import { makeApiAction } from './actions';

export const fetchHolidayScheduleAction = (restId) => (dispatch) => {
  const action = 'FETCH_HOLIDAY_SCHEDULE';
  const data = {
    restId,
    startDate: '2025-12-22', // These can just be hardcoded until next year
    endDate: '2026-01-04',
  };

  dispatch(
    makeApiAction(action, getHolidayScheduleStatus, data, {}, 'getHolidayScheduleStatus', false),
  );
};

export const updateHolidayScheduleAction = (surcharge, days) => (dispatch) => {
  const action = 'UPDATE_HOLIDAY_SCHEDULE';
  const data = {
    surcharge,
    days,
  };

  dispatch(
    makeApiAction(
      action,
      upsertHolidaySchedule,
      data,
      data,
      'upsertHolidaySchedule',
      true,
      null,
      'Your holiday hours have been updated',
    ),
  );
};
